// @ts-nocheck
import intl from 'react-intl-universal';

export const getLanguages = () => [
  { name: intl.get('english'), value: 'en' },
];
